import React from "react";
import { Controller } from "react-hook-form";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import TextField from "@mui/material/TextField";
import {IDaDateTimePickerFieldProps} from "./types";

export const DaDatePickerField: React.FC<IDaDateTimePickerFieldProps<any>> = (
    {
        control,
        name,
        label,
        defaultValue = "",
        readOnly = false,
        required = false,
        size = "medium",
        variant = "standard",
        disableOpenPicker = false,
        errors
    } : IDaDateTimePickerFieldProps<any>

) => {

  return (
      <Controller
          name={name}
          control={control}
          render={({ field }) =>
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <DatePicker
                      {...field}
                      label={required ? `${label} *` : label}
                      readOnly={readOnly}
                      disableOpenPicker={disableOpenPicker}
                      // value={value}
                      // onChange={(newValue) => {
                      //   setValue(newValue);
                      // }}
                      renderInput={(params) => (
                          <TextField
                              {...params}
                              variant={variant}
                              size={size}
                              error={!!errors[name]}
                              helperText={errors[name]?.message ?? ''}
                              fullWidth
                              InputProps={readOnly ? {
                                  // readOnly: true,
                                  className: 'Mui-disabled'} : {}
                              }
                          />
                      )}
                  />
              </LocalizationProvider>
          }
        />
  );
};